import ym from 'react-yandex-metrika';
import ReactPixel from 'react-facebook-pixel';


export function initializeGA(googleCounter) {
  if (typeof window !== 'undefined' && !window.gtag) {
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${googleCounter}`;
    script.async = true;
    document.body.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', googleCounter);
  }
}

export function logPageViewGA(googleCounter, pathname) {
  if (typeof window !== 'undefined' && !!window.gtag) {
    window.gtag('config', googleCounter, { page_path: pathname });
    window.gtag('event', 'page_view');
  }
}


export function logPageViewYM(pathname) {
  ym('hit', pathname);
}


export function initializeFP(pixelCounter) {
  ReactPixel.init(pixelCounter);
  ReactPixel.pageView();
}




// WEBPACK FOOTER //
// ./src/utils/analytics.js